/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */
/* ===== External Libraries ===== */
import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService, UUID } from '@umanforge/common';
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

/* ===== API Configuration ===== */
import { API } from 'constants/api.constant';

/* ===== Interfaces and Types ===== */

/* ===== Services ===== */
import { GlobalService } from './global.service';
import { HolidayLocation } from 'interfaces/holidayLocation.interface';

export class HolidayLocationService {

  /* ===== Send request to create a diary note ===== */
  static getHolidayLocationByEventManager(
    eventManagerId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<HolidayLocation | null> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.HOLIDAY_LOCTION}/by-event-manager/${ eventManagerId }`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<HolidayLocation | null | ''> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          if ( response.data === '' ) {
            response.data = null;
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

}